import React from 'react';
import PropTypes from 'prop-types';

import SourceIcon from './SourceIcon';
import SourceImage from './SourceImage';

function SourceIndicator(props) {
	let {icon, image} = props;

	return icon ? <SourceIcon {...props} />
		: image ? <SourceImage {...props} />
			: null;
}

SourceIndicator.propTypes = {
	icon: PropTypes.string,
	image: PropTypes.string
};

export default SourceIndicator;